import userApi from "./index"

export const getSubjects = async () => {
  try {
    const response = await userApi.get("/subjects")
    return response.data
  } catch (error) {
    throw error
  }
}

export const getSubjectDetailsById = async (subjectId) => {
  try {
    const response = await userApi.get(`/subject-details/${subjectId}`)
    return response.data
  } catch (error) {
    throw error
  }
}
